import { render } from "./CommonlyUsed.vue?vue&type=template&id=42635932&scoped=true"
import script from "./CommonlyUsed.vue?vue&type=script&lang=js"
export * from "./CommonlyUsed.vue?vue&type=script&lang=js"

import "./CommonlyUsed.vue?vue&type=style&index=0&id=42635932&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42635932"]])

export default __exports__